import React from "react";
import { Card, CardBody, Row, Col } from "reactstrap";

const TABS_DEFAULT = [
  { key: "not_started",            bucket: "not_started",            label: "Not Started",            color: "#0060B8" },
  { key: "ready_to_start",         bucket: "ready_to_start",         label: "Ready to Start",         color: "#2dce89" },
  { key: "in_progress",            bucket: "in_progress",            label: "In Progress",            color: "#FEA732" },
  { key: "on_hold",                bucket: "on_hold",                label: "On Hold",                color: "#FF6430" },
  { key: "basic_analysis_started", bucket: "basic_analysis_started", label: "Basic Analysis Started", color: "#E6399B" },
  { key: "checklist_done",         bucket: "checklist_done",         label: "Checklist Done",         color: "#5e60ce" },
  { key: "tb_approved",            bucket: "tb_approved",            label: "TB Approval",            color: "rgba(186, 156, 255, 0.4)" },
  { key: "due_soon",               bucket: "due_soon",               label: "Due in 2 Days",          color: "#d62728" },
  { key: "overdue",                bucket: "overdue",                label: "Overdue",                color: "#8B0000" },
];

// Reviewer / phases mode uses three workflow statuses + due-soon.
const TABS_REVIEWER = [
  { key: "ready_to_start", bucket: "not_started", label: "Not Started",   color: "#0060B8" },
  { key: "in_progress",    bucket: "in_progress", label: "In Progress",   color: "#FEA732" },
  { key: "on_hold",        bucket: "on_hold",     label: "On Hold",       color: "#FF6430" },
  { key: "due_soon",       bucket: "due_soon",    label: "Due in 2 Days", color: "#d62728" },
  { key: "overdue",        bucket: "overdue",     label: "Overdue",       color: "#8B0000" },
];

const AuditSummaryCards = ({ counts, loading, activeBucket, onTabClick, reviewerMode = false }) => {
  const tabs = reviewerMode ? TABS_REVIEWER : TABS_DEFAULT;
  return (
    <Row className="mb-3">
      {tabs.map(({ key, bucket, label, color }) => {
        const active = activeBucket === bucket;
        const wide = tabs.length > 4;
        const widthPct = `${100 / tabs.length}%`;
        return (
          <Col key={key} sm="6" className="mb-2" style={wide ? { flex: "1 1 0", maxWidth: widthPct } : undefined} {...(wide ? {} : { md: "3" })}>
            <Card
              className="shadow-sm"
              style={{
                cursor: "pointer",
                padding: 0, // override global `.card { padding: 22px }` (custom.css) for these cards only
                borderTop: `4px solid ${color}`,
                borderBottom: active ? `3px solid ${color}` : "3px solid transparent",
                background: active ? `${color}10` : "#fff",
                transition: "background 0.2s",
              }}
              onClick={() => onTabClick && onTabClick(bucket)}
            >
              <CardBody className="py-2 px-3">
                <div className="d-flex justify-content-between align-items-start" style={{ gap: 4 }}>
                  <div
                    className="text-uppercase text-muted"
                    title={label}
                    style={{
                      fontSize: "0.7rem",
                      letterSpacing: "0.4px",
                      fontWeight: 600,
                      lineHeight: 1.2,
                      minHeight: "2.4em", // reserve 2 lines so most counts share one baseline (never clips a long label)
                    }}
                  >
                    {label}
                  </div>
                  <span style={{ fontSize: "0.75rem", color: "#888", flexShrink: 0, lineHeight: 1.2 }}>
                    {active ? "▼" : "›"}
                  </span>
                </div>
                <div style={{ fontSize: "1.75rem", fontWeight: 700, color, lineHeight: 1.1, marginTop: 2 }}>
                  {loading ? "…" : (counts?.[key] ?? 0)}
                </div>
              </CardBody>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
};

export default AuditSummaryCards;
